(function () {
  var isLast = function (word) {
    return $(word).next().length > 0 ? false : true;
  };

  var getNext = function (word) {
    return $(word).next();
  };

  var getVisible = function () {
    return document.getElementsByClassName("is-visible-auto-type");
  };

  var getFirst = function () {
    var node = $(".words-wrapper").children().first();
    return node;
  };

  var switchWords = function (current, next) {
    $(current).removeClass("is-visible-auto-type").addClass("is-hidden-auto-type");
    $(next).removeClass("is-hidden-auto-type").addClass("is-visible-auto-type");
  };

  var getStarted = function () {
    //We start by getting the visible element and its sibling
    var first = getVisible();
    var next = getNext(first);

    //If our element has a sibling, it's not the last of the list. We switch the classes
    if (next.length !== 0) {
      switchWords(first, next);
    } else {
      //The element is the last of the list. We remove the visible class of the current element
      $(first).removeClass("is-visible-auto-type").addClass("is-hidden-auto-type");

      //And we get the first element of the list, and we give it the visible class. And it starts again.
      var newEl = getFirst();
      $(newEl).removeClass("is-hidden-auto-type").addClass("is-visible-auto-type");
    }
  };

  var init = function () {
    setInterval(function () {
      getStarted();
    }, 2000);
  };

  init();

  // Auto Typing
  function autoType(elementClass, typingSpeed) {
    var thhis = $(elementClass);
    thhis.css({
      position: "relative",
      display: "inline-block",
    });
    thhis.prepend('<div class="cursor" style="right: initial; left:0;"></div>');
    thhis = thhis.find(".text-js");
    var text = thhis.text().trim().split("");
    var amntOfChars = text.length;
    var newString = "";
    thhis.text("|");
    setTimeout(function () {
      thhis.css("opacity", 1);
      thhis.prev().removeAttr("style");
      thhis.text("");
      for (var i = 0; i < amntOfChars; i++) {
        (function (i, char) {
          setTimeout(function () {
            newString += char;
            thhis.text(newString);
          }, i * typingSpeed);
        })(i + 1, text[i]);
      }
    }, 1500);
  }

  $(document).ready(function () {
    autoType(".type-js", 200);
  });
})();

(function () {

  function initWordRotator(scope = document) {

    const wrappers = scope.querySelectorAll(".words-wrapper");

    wrappers.forEach(wrapper => {

      const words = wrapper.children;
      if (!words.length) return;

      // Reset: hide all
      Array.from(words).forEach(el => el.style.display = "none");

      // Always show first initially
      let current = words[0];
      current.style.display = "block";

      // Clear previous interval (Shopify safe)
      if (wrapper._interval) {
        clearInterval(wrapper._interval);
      }

      wrapper._interval = setInterval(() => {

        // Hide current
        current.style.display = "none";

        // Move to next or first
        if (current.nextElementSibling) {
          current = current.nextElementSibling;
        } else {
          current = wrapper.firstElementChild;
        }

        // Show next
        current.style.display = "block";

      }, 2000);

    });
  }

  // Initial load
  document.addEventListener("DOMContentLoaded", function () {
    initWordRotator();
  });

  // Shopify AJAX / Theme Editor reload
  document.addEventListener("shopify:section:load", function (e) {
    initWordRotator(e.target);
  });

})();